export class FilterBenefitCatalog{
    description!: string;
}